import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"hide-details":"auto","outlined":"","label":_vm.$t('Public ID')},model:{value:(_vm.publicId),callback:function ($$v) {_vm.publicId=$$v},expression:"publicId"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }